// @ts-nocheck
import React from 'react';

import { Modal, PrimaryButton } from '../../components';
import { personaCopy } from '../../config/marketplaceContent';
import { useActivePersona } from '../../context/ActivePersonaContext';

import css from './PersonaSwitchModal.module.css';

const PersonaSwitchModal = () => {
  const {
    switchModal,
    switchBusy,
    switchError,
    confirmPersonaWalletSwitch,
    cancelPersonaWalletSwitch,
  } = useActivePersona();

  if (!switchModal) {
    return null;
  }

  const label =
    switchModal.targetPersona === 'merchant'
      ? personaCopy.merchantWalletLabel
      : personaCopy.runnerWalletLabel;

  return (
    <Modal
      id="PersonaSwitchModal"
      isOpen={Boolean(switchModal)}
      onClose={cancelPersonaWalletSwitch}
      usePortal
      onManageDisableScrolling={() => {}}
    >
      <div className={css.root} data-testid="persona-switch-modal">
        <h2 className={css.title}>{personaCopy.switchModalTitle}</h2>
        <p className={css.body}>
          {personaCopy.switchModalBody.replace('[persona]', label)}
        </p>
        <p className={css.address}>
          {switchModal.requiredAddress?.slice(0, 10)}…{switchModal.requiredAddress?.slice(-6)}
        </p>
        {switchError ? <p className={css.error}>{switchError}</p> : null}
        <div className={css.actions}>
          <button type="button" className={css.secondary} onClick={cancelPersonaWalletSwitch}>
            Cancel
          </button>
          <PrimaryButton
            type="button"
            inProgress={switchBusy}
            onClick={confirmPersonaWalletSwitch}
            data-testid="persona-switch-connect-wallet"
          >
            {personaCopy.switchModalConnect}
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

export default PersonaSwitchModal;
